import {Order} from "./Order";

export class Overview {

  constructor(element) {
    this.element = element;
    this.contentElement = element.querySelector('.overview-content');
    this.mobileButton = element.querySelector('[data-button="overview-toggle"]');
    this.progressBar = element.querySelector('.progress-bar');

    Overview.element = this.element;
    Overview.contentElement = this.contentElement;
    Overview.mobileButton = this.mobileButton;
    Overview.progressBar = this.progressBar;
  }

  get steps() {
    return Array.from(this.element.querySelectorAll('[data-step]'));
  }

  static get steps() {
    return Array.from(Overview.element.querySelectorAll('[data-step]'));
  }

  getStepById(stepId) {
    return this.steps.find(step => step.getAttribute('data-step') === stepId);
  }

  getSiblingSteps(stepId) {
    return this.steps.filter(step => step.getAttribute('data-step') !== stepId);
  }

  activateStepById(stepId) {
    this.getStepById(stepId).setAttribute('data-active', 'true');
    this.updateProgressBar(stepId)
  }

  unsetCurrentSiblingSteps(stepId) {
    const SIBLING_STEPS = this.getSiblingSteps(stepId);
    SIBLING_STEPS.forEach(siblingStep => siblingStep.setAttribute('data-current', 'false'));
    this.updateProgressBar(stepId)
  }

  static resetToStart() {
    const STEPS = Overview.steps;
    STEPS.forEach(step => {
      const isProductSelect = step.getAttribute('data-step') === 'product-select';
      step.setAttribute('data-active', `${isProductSelect}`);
      step.setAttribute('data-current', `${isProductSelect}`);
    })
    Overview.updateProgress()
  }

  setCurrentStep(stepId) {
    this.activateStepById(stepId);
    this.getStepById(stepId).setAttribute('data-current', 'true');
    this.unsetCurrentSiblingSteps(stepId);
    this.updateProgressBar(stepId)
    Order.setPosition(stepId);
  }

  static updateProgress() {
    const STEPS = Overview.steps;
    const ACTIVE_STEPS = Array.from(STEPS).filter(step => {
      return step.getAttribute('data-active') === 'true';
    })

    const PERCENT = (100 / STEPS.length) * ACTIVE_STEPS.length
    Overview.progressBar.style.width = `${PERCENT}%`
  }

  updateProgressBar() {
    const STEPS = this.steps;
    const ACTIVE_STEPS = Array.from(STEPS).filter(step => {
      return step.getAttribute('data-active') === 'true';
    })

    const PERCENT = (100 / STEPS.length) * ACTIVE_STEPS.length
    this.progressBar.style.width = `${PERCENT}%`
  }

  static calcOverviewInnerPixelHeight() {
    const BODY_ELEMENT = Overview.contentElement.querySelector('.overview-body');
    const FOOTER_ELEMENT = Overview.contentElement.querySelector('.overview-footer');

    if (!BODY_ELEMENT || !FOOTER_ELEMENT) return 0;
    return BODY_ELEMENT.getBoundingClientRect().height + FOOTER_ELEMENT.getBoundingClientRect().height;
  }

  static toggleOverviewBox() {
    if (Overview.element.getAttribute('data-active') === 'true') Overview.deactivateOverviewBox();
    else Overview.activateOverviewBox();
  }

  static activateOverviewBox() {
    const OVERVIEW_HEIGHT = Overview.calcOverviewInnerPixelHeight();
    const OVERVIEW_ELEMENT = Overview.element;
    const OVERVIEW_CONTENT_ELEMENT = Overview.contentElement;

    if (OVERVIEW_ELEMENT) OVERVIEW_ELEMENT.setAttribute('data-active', 'true');
    if (OVERVIEW_CONTENT_ELEMENT) OVERVIEW_CONTENT_ELEMENT.style.setProperty('height', `${OVERVIEW_HEIGHT}px`);
  }

  static deactivateOverviewBox() {
    const OVERVIEW_ELEMENT = Overview.element;
    const OVERVIEW_CONTENT_ELEMENT = Overview.contentElement;

    if (OVERVIEW_ELEMENT) OVERVIEW_ELEMENT.setAttribute('data-active', 'false');
    if (OVERVIEW_CONTENT_ELEMENT) OVERVIEW_CONTENT_ELEMENT.style.removeProperty('height');
  }

  static deactivateOverview() {
    Overview.element.classList.add('d-none');
  }
}

export const INSTANTIATE_OVERVIEW = () => {
  const OVERVIEW_ELEMENT = document.querySelector('[data-overview]');
  if (!OVERVIEW_ELEMENT) return;

  return new Overview(OVERVIEW_ELEMENT);
}
